export const form_item_size = 'default';
export const success_color = '#52c41a';
export const failed_color = '#f5222d';
export const warning_color = "#faad14";



// WEBPACK FOOTER //
// ./src/common/theme.js